import React, { useState, useRef, useEffect } from 'react';
import {
    Button, TextField, Typography, IconButton,
    Dialog, DialogActions, DialogContent, DialogTitle, Snackbar
} from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import axios from 'axios';

function RenaiEventCommitment({ data, enabled, onSubmitCommitment }) {
    const [commitment, setCommitment] = useState(data);
    const [modalOpen, setModalOpen] = useState(false);

    const onClick = () => {
        setModalOpen(true);
    };

    const onClose = () => {
        setModalOpen(false);
    };

    const onSubmit = (content) => {
        onSubmitCommitment?.(content);
    };

    useEffect(() => {
        setCommitment(data);
    }, [data]);

    return <>
        <Button variant="contained" color="primary" disabled={!enabled} onClick={onClick}>{!commitment || commitment.state === 'deleted' ? 'Submit AI Commitment' : 'Review commitment'}</Button>
        <RenaiEventCommitmentForm isOpen={modalOpen} onClose={onClose} onSubmit={onSubmit} commitment={commitment} />
    </>;
}

function RenaiEventCommitmentForm({ isOpen, onClose, onSubmit, commitment }) {
    const textarea = useRef(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [error, setError] = useState(null);
    const [editing, setEditing] = useState(!commitment || commitment.state === 'deleted');

    useEffect(() => {
        setEditing(!commitment || commitment.state === 'deleted');
    }, [commitment]);

    const handleSubmit = () => {
        setError(null);
        axios.post("api/renaicommitments/completion", { reflection: textarea.current.value }, { withCredentials: true })
            .then(() => {
                setAlertOpen(true);
                onSubmit?.(textarea.current.value);
            })
            .catch(e => {
                setError(e.response.data.errors.content);
            });
    };

    return <Dialog open={isOpen} onClose={onClose} aria-labelledby={"renai-commitment-dialog-title"} maxWidth={'md'} fullWidth>
        <DialogTitle aria-labelledby={"renai-commitment-dialog-title"}>Commitment</DialogTitle>
        <DialogContent>
            {editing ? <><Typography variant="body1">Please submit your AI commitment !TODO!</Typography>
                <TextField inputRef={textarea}
                    id={"renai-commitment-content"}
                    label="Comittment"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    error={!!error}
                    defaultValue={commitment?.content}
                    helperText={error}
                /></> : <Typography variant="body1" style={{whiteSpace: "pre-line"}}>
                    <IconButton aria-label="edit" onClick={() => setEditing(true)} ><Edit /></IconButton>
                    {commitment?.content}
            </Typography>}
            <Snackbar open={alertOpen} autoHideDuration={5000} onClose={_ => setAlertOpen(false)}>
                <Alert onClose={_ => setAlertOpen(false)} severity="success">
                    Commitment submitted successfully
                </Alert>
            </Snackbar>
        </DialogContent>
        <DialogActions>
            {editing && <Button onClick={handleSubmit} color="primary">Submit</Button>}
            <Button onClick={onClose} color="default">{!editing ? 'Ok' : 'Cancel'}</Button>
        </DialogActions>
    </Dialog>;
}

export default RenaiEventCommitment;